var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.01,
    x: 0.0390625,
    width: 22,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "More"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.0341935 5.37499C0.0354848 5.01032 0.181588 4.6611 0.440362 4.40415C0.699136 4.1472 1.04938 4.00358 1.41405 4.00487L20.6639 4.07304C21.0286 4.07433 21.3778 4.22043 21.6348 4.4792C21.8917 4.73798 22.0353 5.08823 22.0341 5.4529C22.0328 5.81757 21.8867 6.16679 21.6279 6.42374C21.3691 6.68068 21.0189 6.82431 20.6542 6.82302L1.40432 6.75485C1.03965 6.75356 0.690424 6.60746 0.433476 6.34868C0.176529 6.08991 0.0329021 5.73966 0.0341935 5.37499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.38476 12.2548C1.02009 12.2535 0.669839 12.3972 0.411065 12.6541C0.152291 12.911 0.00618794 13.2603 0.00489659 13.6249C0.00360524 13.9896 0.147232 14.3399 0.40418 14.5986C0.661127 14.8574 1.01035 15.0035 1.37502 15.0048L12.3749 15.0438C12.7396 15.045 13.0899 14.9014 13.3486 14.6445C13.6074 14.3875 13.7535 14.0383 13.7548 13.6736C13.7561 13.309 13.6125 12.9587 13.3555 12.6999C13.0986 12.4412 12.7494 12.2951 12.3847 12.2938L1.38476 12.2548Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more_icon.c042899e24f284f2b40c45b6f6d685cd.svg";
export { ForwardRef as ReactComponent };